import { appConfig } from "@/config/app-config";
import { ClientCx } from "@/framework/contexts/ClientCx";
import { UserError, isAlertableOnClient } from "@/framework/errors/UserError";
import { getErrorMessageForDeveloper } from "../errors/getErrorMessageForDeveloper";
import { toUserError } from "../errors/toUserError";
import { logger } from "../logging/client-logging";
import { reportClientError } from "@/modules/error-alerting/client";

export const clientContext: ClientCx = {
  appConfig,
  logger,
  errorReporter: {
    error: (error: unknown): UserError => {
      const e: UserError = toUserError(error);

      console.error(
        `${getErrorMessageForDeveloper(e)}\n${JSON.stringify(
          e.details,
          null,
          2
        )}`
      );
      if (!isAlertableOnClient(e)) {
        console.log("error not alertable on client");
        return e;
      }

      reportClientError(e);
      return e;
    },
  },
};
